import { useContext } from 'react'
import { AuthContext } from '../components/auth/AuthProvider.tsx'

export function useAuth() {
  return useContext(AuthContext)
}
